module.exports = __webpack_public_path__ + "static/banner-compara-1df285e8363cc8d15c3f0ecb605bcd5a.jpeg";